<template>
  <div class="x-filter-container">
    <div :class="['x-filter-content']">
      <div class="x-filter-content-params" ref="content-params">
        <el-row :class="[isExpand ? '' : 'expand']">
          <slot></slot>

          <el-col :span="btnColSpan" class="x-filter-action">
            <!-- <div> -->
            <el-button
              v-if="filterItemLength > 3 && noMove"
              @click="handleExpand"
              class="actionButton"
              :icon="!isExpand ? buttonIcons('searchDown') : buttonIcons('searchUp')"
            >
            </el-button>
            <el-button @click="handleReset">
              {{ secondButton }}
            </el-button>
            <el-button type="primary" @click="handleSearch">
              {{ firstButton }}
            </el-button>
            <!-- </div> -->
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import { buttonIcons } from '@main/common/utils/buttonIcon'

  export default {
    name: 'XFilter',
    props: {
      firstButton: {
        type: String,
        default: '搜索'
      },
      secondButton: {
        type: String,
        default: '重置'
      },
      noMove: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        buttonIcons,
        isExpand: false,
        searchParams: {},
        filterItemLength: 0,
        clientWidth: document.documentElement.clientWidth
      }
    },

    computed: {
      formItemColSpan() {
        if (this.clientWidth < 768) {
          return 12
        }
        if (this.clientWidth >= 768 && this.clientWidth < 992) {
          return 8
        }
        if (this.clientWidth >= 992 && this.clientWidth < 1200) {
          return 8
        }
        return 6
      },
      totalCol() {
        return 24 / this.formItemColSpan
      },
      resetCol() {
        return this.filterItemLength % this.totalCol
      },
      btnColSpan() {
        let span = 24
        if (!this.isExpand) {
          span =
            this.filterItemLength < 3 ? (this.totalCol - this.resetCol) * this.formItemColSpan : this.formItemColSpan
        } else if (this.isExpand && this.resetCol) {
          span = (this.totalCol - this.resetCol) * this.formItemColSpan
        }
        return span
      },
      getRowStyle() {
        let isFilterClass = ''
        if (!this.isExpand) {
          isFilterClass = 'visble-filter'
        }
        return isFilterClass
      }
    },
    mounted() {
      this.filterItemLength = document.querySelectorAll('.x-filter-item.search-form-item').length
    },
    beforeMount() {
      window.addEventListener('resize', () => {
        this.clientWidth = document.documentElement.clientWidth
      })
    },
    methods: {
      handleClick() {
        this.$emit('return')
      },
      handleSearch() {
        this.$emit('search')
      },
      handleReset() {
        this.searchParams = {}
        this.$emit('reset')
      },
      handleExpand() {
        this.isExpand = !this.isExpand
      }
    }
  }
</script>

<style lang="scss" scoped>
  // @import '../../../common/assets/style/variables';

  .x-filter-container {
    width: 100%;
    margin: 0;
    padding: 0;
    border: 1px solid #ebebeb;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 5px 2px 12px 0 rgb(0 0 0 / 10%);

    .x-filter-title-bar {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      height: 48px;
      padding: 0 16px;
      border-color: #ebebeb;
      border-bottom-width: 1px;
      border-bottom-style: solid;

      .filter-title {
        font-size: 14px;
        color: rgb(62 65 69);

        .el-icon-arrow-left {
          font-size: 20px;
          cursor: pointer;
          vertical-align: middle;
          color: rgb(62 65 69);
        }
      }

      .x-filter-right-arrow {
        display: flex;
        align-items: center;
        flex-direction: row;
        cursor: pointer;

        > label {
          cursor: pointer;
        }

        .x-filter-icon {
          margin-left: 8px;
          cursor: pointer;

          /* Firefox 4 */
          transition: transform 0.3s;

          /* Safari 和 Chrome */

          /* Opera */

          i {
            font-size: 18px;
          }
        }
      }
    }

    .x-filter-content {
      display: flex;
      flex-direction: column;
      padding: 16px;
      padding-bottom: 0;

      /* Firefox 4 */
      transition: all 0.3s ease;

      /* Safari 和 Chrome */

      /* Opera */

      &.expand {
        // overflow: hidden;
        // height: 82px;

        // span:nth-child(n + 4) {
        //   display: none;
        // }
      }

      .x-filter-content-params {
        // display: flex;
        // flex: 1;
        // flex-flow: row wrap;

        // flex-direction: row;
        // flex-wrap: wrap;

        .x-filter-item.search-form-item {
          display: block;
        }
      }

      .x-filter-action {
        margin-top: 30px;
        // align-self: flex-end;
        // flex: 1;
        margin-bottom: 16px;
        // flex-direction: row;
        text-align: right;

        .right-btn {
          margin-left: 16px;
        }
      }

      .isExpand {
        position: sticky;
        right: 0;
        bottom: 0;
        background: #fff;
      }
    }
  }

  .expand {
    // overflow: hidden;
    height: 82px;

    // span:nth-child(n + 4) {
    //   display: none;
    // }
  }

  .expand .x-filter-item {
    background: black;
  }

  .actionButton ::v-deep.el-button--default i {
    transform: rotate(90deg) !important;
  }
</style>
<style lang="scss">
  .el-row {
    &.expand {
      height: 82px;
      // overflow: hidden;
      // background-color: gold;

      span:nth-child(n + 4) {
        display: none;
      }
    }
  }
</style>
